import { feature as liveChatFeature } from '@central-products/live-chat-flow';
import { isNative } from '../../utils';
import { ACCOUNT_ACTION_IDS } from '@central-products/interface-account-actions';

function waitForVisitorId(maxRetries) {
  const oldVal = window.utag && window.utag.dle_visitor_id;
  return new Promise((resolve) => {
    let count = 0;
    const int = setInterval(() => {
      const newVal = window.utag && window.utag.dle_visitor_id;
      if (newVal !== oldVal || count >= maxRetries) {
        clearInterval(int);
        resolve(newVal);
        return;
      }
      count++;
    }, 500);
  });
}

function syncAudiencesViaVisitorService(bootstrapperFeatures, params) {
  const CALLBACK_NAME = 'liveChatPluginCb';
  window.kraken[CALLBACK_NAME] = function liveChatPluginCb(data) {
    if (!data.audiences) {
      return;
    }
    const audiences = Object.values(data.audiences);
    bootstrapperFeatures['live-chat-flow'].setAudiences(audiences);
  };

  bootstrapperFeatures['account-info'].onStateChanged(async ({ state }) => {
    if (state !== 'ACCOUNT_INFO_EXISTS') {
      return;
    }

    const visitorId = await waitForVisitorId(params.visitorIdMaxRetries);

    await fetch(params.tealiumInitUrl.replace('$(visitorId)', visitorId));

    const script = document.createElement('script');
    script.onload = function onload() {
      script.parentNode.removeChild(script);
    };
    script.src =
      params.visitorServiceUrl.replace('$(visitorId)', visitorId) +
      `?callback=window.kraken.${CALLBACK_NAME}&rnd=${new Date().getTime()}`;
    document.body.appendChild(script);
  });
}

export const liveChatPlugin = {
  beforeBootstrap({ addBootstrapperFeature, params }) {
    if (isNative()) {
      return;
    }

    addBootstrapperFeature(liveChatFeature, params);
  },
  postBootstrap({ bootstrapperFeatures, params }) {
    if (params.syncAudiencesViaVisitorService) {
      syncAudiencesViaVisitorService(bootstrapperFeatures, params);
    }
    bootstrapperFeatures['account-actions'].onActionRequested(({ actionId, data }) => {
      if (actionId === ACCOUNT_ACTION_IDS.LIVE_CHAT_START) {
        bootstrapperFeatures['live-chat-flow'].activateEngagement(data);
      }
    });
  },
};
